import styled from 'styled-components'

export const TestWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: rgb(240, 240, 240);
  text-align: center;
  padding: 6rem 2rem;
  color: #D6A449;
`
